import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';

export default class extends Controller {
  connect() {
  }
}
